module.exports = __webpack_public_path__ + "img/side-image-1.f18b520c.jpg";